module.exports = __webpack_public_path__ + "images/6c201e3b2ad1cb2bbc021248780be712.svg";